<template>
    <div class="form-group">
        <label v-if="label">{{ label }}<br/></label>
        <ul class="list-inline">
            <li v-for="option in options">
                <label><input type="checkbox" :value="option" v-model="localChecked" /> {{ option }}</label>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        options: { type: Array },
        label: { type: String },
        value: { type: Array }
    },
    data() {
        return {
            localChecked: this.value || []
        }
    },
    watch: {
        value(newValue, oldValue) {
            this.localChecked = this.value;
        },
        localChecked(newValue, oldValue) {
            this.$emit('input', newValue);
        }
    },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/primitives/CheckBoxGroup.vue